module.exports = __webpack_public_path__ + "img/stefano-ciociola-6TePgVf1CvI-unsplash.9767eac1.jpg";